import { __generator } from "tslib";
import React from 'react';
import { Trans } from 'react-i18next';
import { call, all, put, take, race, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions as StreamActions } from '../../Stream';
import { getCurrentStreamId, getCurrentGallection, getCurrentSubfolderId, getGallectionById, } from '../selectors';
import { deselectAll } from '../actions';
import setGallectionCover from './setGallectionCover';
import updateGallectionSize from './updateGallectionSize';
import { confirmYes, confirmNo, pushGlobalConfirmationModalForMM, } from '../../Modals/redux/actionCreators';
import { isPremiumGallection, getPremiumGallectionType, } from '../../utils/gallections';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import { getDeviationEntityIds } from '../../redux/normalizr/schemas/deviation';
import { checkAndWarnIfDeviationsAreNotSupportedForPremium } from './helpers';
import { getGallectionType } from '../helpers';
export default function (action) {
    var _a, targetFolderId, deviations, _b, streamId, currentGallection, targetGallection, currentSubfolderId, isFromPremiumFolder, isToPremiumFolder, confirmationTextTransKey, confirmationTitleTransKey, fromType, toType, confirmationTitleTransMap, confirmationTextTransMap, hasUnsupportedDeviationSelected, no, entityIds, deviationIds, params;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, targetFolderId = _a.targetFolderId, deviations = _a.deviations;
                return [4 /*yield*/, select(function (state) { return ({
                        streamId: getCurrentStreamId(state),
                        currentGallection: getCurrentGallection(state),
                        currentSubfolderId: getCurrentSubfolderId(state),
                        targetGallection: getGallectionById(state, targetFolderId),
                    }); })];
            case 1:
                _b = _d.sent(), streamId = _b.streamId, currentGallection = _b.currentGallection, targetGallection = _b.targetGallection, currentSubfolderId = _b.currentSubfolderId;
                if (!currentGallection || !targetGallection) {
                    return [2 /*return*/];
                }
                isFromPremiumFolder = isPremiumGallection(currentGallection);
                isToPremiumFolder = isPremiumGallection(targetGallection);
                if (!(isFromPremiumFolder || isToPremiumFolder)) return [3 /*break*/, 6];
                fromType = getPremiumGallectionType(currentGallection) || 'regular';
                toType = getPremiumGallectionType(targetGallection) || 'regular';
                // Moving between WO folders is permitted
                if (fromType === 'watchers' && toType === 'watchers') {
                    return [2 /*return*/];
                }
                confirmationTitleTransMap = {
                    paid: {
                        paid: 'mediapopup.confirmationPopup.moveDeviation.title.fromPaidToPaid',
                        watchers: 'mediapopup.confirmationPopup.moveDeviation.title.fromPaidToWatchersOnly',
                        regular: 'mediapopup.confirmationPopup.moveDeviation.title.fromPaidToRegular',
                    },
                    watchers: {
                        paid: 'mediapopup.confirmationPopup.moveDeviation.title.fromWatchersOnlyToPaid',
                        regular: 'mediapopup.confirmationPopup.moveDeviation.title.fromWatchersOnlyToRegular',
                    },
                    regular: {
                        paid: 'mediapopup.confirmationPopup.moveDeviation.title.fromRegularToPaid',
                        watchers: 'mediapopup.confirmationPopup.moveDeviation.title.fromRegularToWatchersOnly',
                    },
                };
                confirmationTextTransMap = {
                    paid: {
                        paid: 'mediapopup.confirmationPopup.moveDeviation.text.fromPaidToPaid',
                        watchers: 'mediapopup.confirmationPopup.moveDeviation.text.fromPaidToWatchersOnly',
                        regular: 'mediapopup.confirmationPopup.moveDeviation.text.fromPaidToRegular',
                    },
                    watchers: {
                        paid: 'mediapopup.confirmationPopup.moveDeviation.text.fromWatchersOnlyToPaid',
                        regular: 'mediapopup.confirmationPopup.moveDeviation.text.fromWatchersOnlyToRegular',
                    },
                    regular: {
                        paid: (React.createElement(Trans, { i18nKey: "mediapopup.confirmationPopup.moveDeviation.text.fromRegularToPaid" },
                            "\u2022 Only your paying Supporters will have access to it.",
                            React.createElement("br", null),
                            "\u2022 It will become locked for all your non-Supporters and will affect Collections, Groups, Profile Spotlights,",
                            ' ',
                            React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-happens-when-i-move-deviations-in-or-out-of-premium-galleries" }, "and more"),
                            ".",
                            React.createElement("br", null),
                            "\u2022 Prints and Premium Downloads will be disabled.",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            "Are you sure you want to move this deviation?")),
                        watchers: (React.createElement(Trans, { i18nKey: "mediapopup.confirmationPopup.moveDeviation.text.fromRegularToWatchersOnly" },
                            "\u2022 Only your watchers will have access to it.",
                            React.createElement("br", null),
                            "\u2022 It will become locked for deviants who don\u2019t watch you and will affect Collections, Groups, Profile Spotlights,",
                            ' ',
                            React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-happens-when-i-move-deviations-in-or-out-of-premium-galleries" }, "and more"),
                            ".",
                            React.createElement("br", null),
                            "\u2022 Prints and Premium Downloads will be disabled.",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            "Are you sure you want to move this deviation?")),
                    },
                };
                confirmationTitleTransKey = confirmationTitleTransMap[fromType][toType];
                confirmationTextTransKey = confirmationTextTransMap[fromType][toType];
                if (!isToPremiumFolder) return [3 /*break*/, 3];
                return [4 /*yield*/, call(checkAndWarnIfDeviationsAreNotSupportedForPremium, deviations)];
            case 2:
                hasUnsupportedDeviationSelected = _d.sent();
                if (hasUnsupportedDeviationSelected) {
                    confirmationTitleTransKey =
                        'mediapopup.confirmationPopup.moveDeviation.title.unsupported';
                    confirmationTextTransKey =
                        'mediapopup.confirmationPopup.moveDeviation.text.unsupported';
                }
                _d.label = 3;
            case 3: return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                    titleTransKey: confirmationTitleTransKey,
                    textTransKey: confirmationTextTransKey,
                    confirmBtnLabelTransKey: 'mediapopup.confirmationPopup.moveDeviation.confirm',
                    cancelBtnLabelTransKey: 'popup.cancel',
                    icon: React.createElement(Warning, null),
                }))];
            case 4:
                _d.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 5:
                no = (_d.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                _d.label = 6;
            case 6:
                entityIds = getDeviationEntityIds(deviations);
                return [4 /*yield*/, all([
                        put(StreamActions.deleteItems({ streamId: streamId, items: entityIds })),
                        put(deselectAll()),
                    ])];
            case 7:
                _d.sent();
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: targetGallection,
                        deviation: deviations[0],
                        onlyIfMissing: true,
                    })];
            case 8:
                _d.sent();
                return [4 /*yield*/, call(updateGallectionSize, targetFolderId, deviations.length)];
            case 9:
                _d.sent();
                deviationIds = deviations.map(function (deviation) { return deviation.deviationId; });
                params = {
                    type: (_c = getGallectionType(currentGallection)) !== null && _c !== void 0 ? _c : 'collection',
                    src_folderid: currentSubfolderId || currentGallection.folderId,
                    target_folderid: targetFolderId,
                    deviationids: deviationIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/move_deviations',
                        data: params,
                    })];
            case 10:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=moveDeviations.js.map